export const datapoints = {
    AttFolderPickerOpened: {
        name: 'AttFolderPickerOpened',
    },
};
